import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from './spinner/spinner.component';
import { ControlMessagesComponent } from '../control-messages/control-messages.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  TranslateService,
  TranslateModule,
  TranslateLoader,
  TranslatePipe
} from "@ngx-translate/core";

import { GooglePlacesDirective } from '../../directives/google-places.directive';
import { FaqComponent } from './footer/faq/faq.component';
import { PrivacyPolicyComponent } from './footer/privacy-policy/privacy-policy.component';
import { UsageInstructionsComponent } from './footer/usage-instructions/usage-instructions.component';
import { ContactComponent } from './footer/contact/contact.component';
@NgModule({
  declarations: [
    SpinnerComponent,
    ControlMessagesComponent,
    GooglePlacesDirective,
    FaqComponent,
    PrivacyPolicyComponent,
    UsageInstructionsComponent,
    ContactComponent
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
  ],
  exports: [
    SpinnerComponent,
    ControlMessagesComponent,
    TranslateModule,
    GooglePlacesDirective,
  ],
  providers: [

  ]
})
export class SharedModule { }

export function createTranslateLoader(http: HttpClient) {
  
  console.log('in core module')
  console.log(http, '/assets/i18n', '.json')
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}
